import { Button, Icon, NewModal as Modal } from '@digitools/honest-react';
import moment from 'moment';
import React, { useState } from 'react';
import { formatDate, SubmitUnplannedAbsence } from '../api/UnplannedAbsenceApi';
import { useDisclosure } from '@mantine/hooks';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
const DeleteAbsenceButton = ({ absence, getLeaves, setSuccessMessage, setFailureMessage, onDelete, }) => {
    const [disableButton, setDisableButton] = useState(false);
    const { trackEvent } = useTealium();
    const onSuccess = () => {
        setDisableButton(false);
        getLeaves();
        setSuccessMessage('You have successfully deleted an Unplanned Absence.');
        onDelete?.();
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.BUTTON,
            event_name: 'delete absence',
            event_type: TEALIUM_EVENT.EVENT_TYPE.UNPLANNED_ABSENCE,
            event_version: TEALIUM_EVENT.EVENT_STATUS.CONFIRMATION,
        });
    };
    const onFailure = () => {
        setDisableButton(false);
        getLeaves();
        const failureMessage = 'There was a problem deleting an Unplanned Absence. Please try again later.';
        setFailureMessage(failureMessage);
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.ERROR,
            event_name: failureMessage,
            event_type: TEALIUM_EVENT.EVENT_TYPE.UNPLANNED_ABSENCE,
        });
    };
    const { post: postAbsence } = SubmitUnplannedAbsence(onSuccess, onFailure);
    const deleteAbsence = () => {
        setDisableButton(true);
        postAbsence({
            payload: {
                absenceDate: formatDate(absence.uaStartDate),
                absReason: absence.absReason,
                absType: absence.absType,
                additionalDates: absence.additionalDates ? absence.additionalDates.map(date => '111/11/1') : [],
                associatedLeaveNumber: absence.associatedLeave?.trim(),
                associatedTransNum: absence.transNum,
                deathFollowsPolicy: absence.uaHasDeath,
                duration: absence.uaDuration,
                endTime: moment.utc(absence.uaEndTime).format('HH:mm'),
                hasAssociatedLeave: absence.uaHasLeave,
                spansMidnight: absence.uaSpansMidnight,
                startTime: moment.utc(absence.uaStartTime).format('HH:mm'),
                transType: 'D',
            },
        });
    };
    const TrashButton = ({ showModal }) => (<Button onClick={showModal} buttonType='text' className='p-2' disabled={disableButton} title='Delete Absence' data-testid={`delete-${absence.transNum}`}>
      <Icon name='trash' color={'secondary'}/>
    </Button>);
    const [isOpen, { open, close }] = useDisclosure(false);
    return (<>
      <Modal closeOnClickOutside={true} centered={true} opened={isOpen} onClose={() => {
            close();
        }} cancelButtonText={'Cancel'} submitButtonText={'Delete Absence'} onSubmit={() => {
            deleteAbsence();
            close();
        }} cancelButtonProps={{
            'data-testid': 'cancel-delete-btn',
            buttonType: 'secondary',
            'aria-label': 'cancel delete absence'
        }} submitButtonProps={{
            'data-testid': 'confirm-delete-btn',
            buttonType: 'primary',
            'aria-label': 'confirm delete absence'
        }} withCloseButton={false} title='Please Confirm'>
        <p data-testid='delete-modal'>Are you sure that you want to delete this absence?</p>
      </Modal>
      <TrashButton showModal={open}/>
    </>);
};
export default DeleteAbsenceButton;
